import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "mt-6" }

import { storeToRefs } from "pinia";

import TitleHeader from "@/components/TitleHeader.vue";
import SubscriptionPanel from "@/components/SubscriptionPanel.vue";

import { useUserStore } from "@/store";
import { userHasRole } from "@/utils/roles";


export default /*#__PURE__*/_defineComponent({
  __name: 'SubscriptionPage',
  setup(__props) {

const { user } = storeToRefs(useUserStore());

if (userHasRole(user.value.roles, ["professional", "parent", "brick-club-family", "paid-professional"])) {
  window.location.href = "/error";
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(TitleHeader, {
      title: _ctx.$t('my-profile')
    }, null, 8, ["title"]),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(SubscriptionPanel, { user: _unref(user) }, null, 8, ["user"])
    ])
  ]))
}
}

})